import React, { useEffect, useState } from "react";
import { ReactComponent as CalenderIcon } from "../../../../assets/calender.svg";
import { ReactComponent as ClockIcon } from "../../../../assets/clock.svg";
import { ReactComponent as ClockBoxIcon } from "../../../../assets/clock-box.svg";
import { ReactComponent as PresentationIcon } from "../../../../assets/presentation.svg";
import { ReactComponent as ScannerIcon } from "../../../../assets/iconamoon_scanner.svg";
import { ReactComponent as GreaterThanIcon } from "../../../../assets/greater-than-icon.svg";
import Button from "../../../../component/common/Button";
import { Link, NavLink } from "react-router-dom";
import { useUser } from "../../../../context/UserContext";

const EventRightDetails = ({ data }) => {
  const { isSimpleUser } = useUser();

  // Destructure the necessary fields from data
  const {
    id = null,
    eventName = "",
    eventDate = "",
    eventStartTime = "",
    eventEndTime = "",
  } = data?.event || {};

  const {
    ticketType = "",
    isFree = false,
    ticketPrice = 0,
    seatColour = "",
    ticketBadges: { tAndC = false, vip = false, silver = false } = {},
    seatType = "",
    eventId = null,
    ticketStatus = "",
    createdAt = "",
    updatedAt = "",
  } = data?.ticketPrices || {};

  // State for countdown
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
  });

  // Mock sale end date (replace this later once,have actual sale end time from  API)@AnuragKharwar @Gokuhere18
    const saleEndDate = new Date("2024-10-31T23:59:59");

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const timeLeft = saleEndDate - now; // Time difference in milliseconds

      if (timeLeft <= 0) {
        clearInterval(interval);
        setCountdown({ days: 0, hours: 0, minutes: 0 });
      } else {
        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor(
          (timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        setCountdown({ days, hours, minutes });
      }
    }, 1000);

    return () => clearInterval(interval); // Clean up on unmount
  }, []);

  return (
    <div className="w-full lg:w-[40%]">
      <div className="rounded-[10px] min-h-[232px] !px-[10px] xs:px-[16px] py-[20px] bg-[#F5F6FA]">
        {/* Date and Time */}
        <div className="flex items-center justify-between border-b border-b-[#D2DCF4] pb-[12px]">
          <div className="flex items-center">
            <CalenderIcon />
            <h6 className="text-[#263238] text-sm ml-[10px]">
              {eventDate
                ? new Date(eventDate).toLocaleDateString()
                : "Mon 24 Jan"}
            </h6>
          </div>
          <div className="flex items-center">
            <ClockIcon />
            <h6 className="text-[#A5AFC0] text-sm ml-[6px]">Show starts</h6>
            <h6 className="text-[#263238] text-sm ml-[10px]">
              {eventStartTime || "21:00"}
            </h6>
          </div>
        </div>

        {/* Sale Countdown */}
        <div className="bg-white flex-wrap xs:gap-0 gap-2 rounded-[10px] w-full py-[10px] !px-[10px] xs:px-[20px] mt-[16px] mb-[20px] flex justify-between items-center">
          <div className="flex items-center gap-[16px] ">
            <div className="bg-[#8AD4EE] shadow-clock-shadow rounded-[4px] w-[24px] h-[24px] overflow-hidden ">
              <ClockBoxIcon />
            </div>
            <div>
              <h1 className="text-blue-color font-semibold">Buy now</h1>
              <h6 className="text-[#263238] text-xs">Sale ends in</h6>
            </div>
          </div>

          <div className="flex items-center gap-[14px]">
            {/* Countdown for Days, Hours, Mins */}
            <div>
              <h1 className="text-blue-color font-medium text-[20px] xs:text-[24px]">
                {countdown.days}
              </h1>
              <p className="text-[#A5AFC0] text-[10px] text-center">Days</p>
            </div>
            <span className="text-blue-color text-[20px] xs:text-[24px] font-medium">
              :
            </span>
            <div>
              <h1 className="text-blue-color font-medium text-[20px] xs:text-[24px]">
                {countdown.hours}
              </h1>
              <p className="text-[#A5AFC0] text-[10px] text-center">Hours</p>
            </div>
            <span className="text-blue-color text-[20px] xs:text-[24px] font-medium">
              :
            </span>
            <div>
              <h1 className="text-blue-color font-medium text-[24px]">
                {countdown.minutes}
              </h1>
              <p className="text-[#A5AFC0] text-[10px] text-center">Mins</p>
            </div>
          </div>
        </div>

        {/* Tickets Section */}
        <div className="flex justify-between items-center flex-wrap xs:gap-0 gap-2">
          <div>
            <h6 className="text-[#A5AFC0] text-sm">Tickets Starts from:</h6>
            <h1 className="text-[#263238] text-xl xs:text-2xl font-medium mt-[6px]">
              {ticketPrice} USD
            </h1>
          </div>
          <Link
            to={
              isSimpleUser
                ? `/events/${id}/booking`
                : `/events/${id}/analaytics`
            }
          >
            <Button
              content={isSimpleUser ? "Select Tickets" : "View Tickets"}
              classes="text-sm py-[13px] self-center  px-[36px] bg-blue-color mb-0"
            />
          </Link>
        </div>
      </div>

      {/* Additional Actions for Admin Users */}
      {!isSimpleUser && (
        <>
          <NavLink
            to={`/events/${id}/analaytics`}
            className="bg-[#F5F6FA] flex items-center justify-between rounded-[10px] w-full p-[16px] mt-[16px]"
          >
            <div className="flex items-center">
              <PresentationIcon />
              <h2 className="ml-[16px] text-black">Event Details</h2>
            </div>
            <GreaterThanIcon />
          </NavLink>
          <NavLink
            to={`/events/${id}/scanner`}
            className="bg-[#F5F6FA] flex items-center justify-between rounded-[10px] w-full p-[16px] mt-[16px]"
          >
            <div className="flex items-center">
              <ScannerIcon />
              <h2 className="ml-[16px] text-black">Edit Ticket scanners</h2>
            </div>
            <GreaterThanIcon />
          </NavLink>
        </>
      )}
    </div>
  );
};

export default EventRightDetails;
